import generic_backend_request_post from 'functions/server/generic_backend_request_post';

/**
 * Delete saved items. Unknown ids are not an error — they simply are not
 * counted — so a retry after a dropped response is safe.
 *
 * @param {string[]} itemIds
 * @returns {Promise<{deleted: number}>}
 */
async function saved_items_delete(itemIds) {
  return generic_backend_request_post({ item_ids: itemIds }, '/saved_items_delete');
}

export default saved_items_delete;
